// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-item {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-top: 1rem;
    margin-bottom: 1rem;
    line-height: 3.5rem;
    background-color: #fff;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    padding: 1rem 2rem;
}

.topic-item:hover {
    transition: 0.1s;
    box-shadow: 0px 0px 8px 1px #26a69a !important;
}

.topic-item .topic-item__content {
    display: flex;
    cursor: pointer;
}

    .topic-item .topic-item__content-grow {
        flex-grow: 1;
        display: flex;
        flex-direction: row;
        width: min-content;
        overflow: hidden;
    }

.topic-item .topic-item__identifier {
    color: #cccccc;
    font-size: 1.6rem;
}
.topic-item .topic-item__name {
    padding-left: 1rem;
    margin-right: auto;
    overflow: hidden;
    text-overflow: ellipsis;
}

.topic-item .topic-item__button {
    margin-left: 0.4rem;
    margin-right: 0.4rem;
}

.topic-item .topic-item__button-edit {
    background-color: #1696a6;
}

.topic-item .topic-item__button-delete {
    background-color: #d22e37;
}

.topic-item .topic-item__button-save {
    background-color: #d6ac17;
}

.topic-item .topic-item__button-discard {
    background-color: #d22e37;
}

.editing-nlp {
    margin-bottom: 16px !important;
}

.topic-item input.editing-nlp {
    padding-bottom: 5px;
    height: auto !important;
    margin-top: 7px;
    margin-bottom: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-list/topic-item/TopicItem.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,+GAA+G;IAC/G,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;IAEI;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;IACpB;;AAEJ;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,6BAA6B;AACjC","sourcesContent":[".topic-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    position: relative;\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n    line-height: 3.5rem;\r\n    background-color: #fff;\r\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\r\n    border-radius: 2px;\r\n    padding: 1rem 2rem;\r\n}\r\n\r\n.topic-item:hover {\r\n    transition: 0.1s;\r\n    box-shadow: 0px 0px 8px 1px #26a69a !important;\r\n}\r\n\r\n.topic-item .topic-item__content {\r\n    display: flex;\r\n    cursor: pointer;\r\n}\r\n\r\n    .topic-item .topic-item__content-grow {\r\n        flex-grow: 1;\r\n        display: flex;\r\n        flex-direction: row;\r\n        width: min-content;\r\n        overflow: hidden;\r\n    }\r\n\r\n.topic-item .topic-item__identifier {\r\n    color: #cccccc;\r\n    font-size: 1.6rem;\r\n}\r\n.topic-item .topic-item__name {\r\n    padding-left: 1rem;\r\n    margin-right: auto;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.topic-item .topic-item__button {\r\n    margin-left: 0.4rem;\r\n    margin-right: 0.4rem;\r\n}\r\n\r\n.topic-item .topic-item__button-edit {\r\n    background-color: #1696a6;\r\n}\r\n\r\n.topic-item .topic-item__button-delete {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.topic-item .topic-item__button-save {\r\n    background-color: #d6ac17;\r\n}\r\n\r\n.topic-item .topic-item__button-discard {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.editing-nlp {\r\n    margin-bottom: 16px !important;\r\n}\r\n\r\n.topic-item input.editing-nlp {\r\n    padding-bottom: 5px;\r\n    height: auto !important;\r\n    margin-top: 7px;\r\n    margin-bottom: 5px !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
